@if (showTable) {
  <snelstart-ui-table [config]="tableConfig">
    <snelstart-ui-table-col
      columnType="string"
      name="label"
      [showFilter]="false"
      [showSort]="false"
      width="600"
      i18n-displayName
    >
      <snelstart-ui-table-col-header>
        <div style="font-size: 13px; color: #00200b ">
          {{ naamVennootschap }}
        </div>
      </snelstart-ui-table-col-header>

      <snelstart-ui-table-expanded-row>
        @for (option of options; track option.value) {
          <div>
            @for (subOnderdeel of option.subonderdelen ?? []; track subOnderdeel.value) {
              @if (subOnderdeel.visible) {
                <div>
                  <snelstart-ui-button
                    icon="chevron-right" type="link" class="ps-5"
                    (click)="navigateToSubPage(subOnderdeel.pageMapping)">
                    <div [ngStyle]="subOnderdeel.pageMapping === activePage ? {'color': '#0073dd', 'font-weight': 'bold'} : {}">
                      {{ subOnderdeel.label }}
                    </div>
                  </snelstart-ui-button>
                </div>
              }
            }
          </div>
        }
      </snelstart-ui-table-expanded-row>
    </snelstart-ui-table-col>

    <snelstart-ui-table-col name="onderdelenAanvullendeTekst"
                            [showFilter]="false"
                            [showSort]="false"
                            columnType="currency"
                            [decimals]="2"
                            i18n-displayName
                            width="300">
      <snelstart-ui-table-col-header></snelstart-ui-table-col-header>

      <snelstart-ui-table-col-data>
        <ng-template let-record="record">
          @if (record.value === 2) {
            <a>Fiscale winst:</a>
          }
          @if (record.value === 3) {
            <a>Winstcorrecties:</a>
          }
          @if (record.value === 4) {
            <a>Belastbaar bedrag:</a>
          }
          @if (record.value === 5) {
            <b><a>Te betalen:</a></b>
          }
        </ng-template>
      </snelstart-ui-table-col-data>
    </snelstart-ui-table-col>

    <snelstart-ui-table-col name="berekening"
                            [showFilter]="false"
                            [showSort]="false"
                            columnType="currency"
                            [decimals]="2"
                            i18n-displayName
                            width="300"
    >
      <snelstart-ui-table-col-header>
        Dit boekjaar
      </snelstart-ui-table-col-header>

      <snelstart-ui-table-col-data>
        <ng-template let-record="record">
          @if (record.value === 2) {
            <a>{{ this.saldoFiscaleWinstberekening.toLocaleString() }}</a>
          }
          @if (record.value === 3 && this.winstCorrecties >= 0) {
            <a>{{ this.winstCorrecties.toLocaleString() }}</a>
          }
          @if (record.value === 3 && this.winstCorrecties < 0) {
            <a>{{ (this.winstCorrecties * -1).toLocaleString() }}</a>
          }
          @if (record.value === 4) {
            <a>{{ this.belastbaarBedrag.toLocaleString() }}</a>
          }
          @if (record.value === 5) {
            <b><a>{{ this.verschuldigdeVennootschapsbelasting.toLocaleString() }}</a></b>
          }
        </ng-template>
      </snelstart-ui-table-col-data>
    </snelstart-ui-table-col>

<!--    <snelstart-ui-table-col name="vergelijkendeCijfers"-->
<!--                            [showFilter]="false"-->
<!--                            [showSort]="false"-->
<!--                            columnType="currency"-->
<!--                            [decimals]="2"-->
<!--                            i18n-displayName-->
<!--                            width="250px"-->
<!--    >-->
<!--      <snelstart-ui-table-col-header>-->
<!--        Vorig boekjaar-->
<!--      </snelstart-ui-table-col-header>-->

<!--      <snelstart-ui-table-col-data>-->
<!--        <ng-template let-record="record">-->
<!--          <ng-container>-->
<!--            <a *ngIf="record.value === 2">{{ saldoFiscaleWinstberekeningVorigjaar }}</a>-->
<!--          </ng-container>-->
<!--          <ng-container *ngIf="winstCorrectiesVorigJaar !== 0">-->
<!--            <a *ngIf="record.value === 3">{{ winstCorrectiesVorigJaar.toLocaleString() || '-' }}</a>-->
<!--          </ng-container>-->
<!--          <ng-container *ngIf="winstCorrectiesVorigJaar === 0 ">-->
<!--            <a *ngIf="record.value === 3">-</a>-->
<!--          </ng-container>-->

<!--          <ng-container>-->
<!--            <a *ngIf="record.value === 4">{{ this.belastbaarBedragVorigjaar.toLocaleString() || '-' }}</a>-->
<!--          </ng-container>-->
<!--          <ng-container>-->
<!--            <b>-->
<!--              <a *ngIf="record.value === 5">{{ this.verschuldigdeVennootschapsbelastingVorigjaar.toLocaleString() || '-' }}</a>-->
<!--            </b>-->
<!--          </ng-container>-->
<!--        </ng-template>-->
<!--      </snelstart-ui-table-col-data>-->
<!--    </snelstart-ui-table-col>-->

  </snelstart-ui-table>

  <snelstart-venture-fiscaal-domain-logic-service [(dialogVisible)]="this.dialogVisible"
                                                  [title]="'Nieuwe aangifte vennootschapsbelasting aanmaken'"
  >
  </snelstart-venture-fiscaal-domain-logic-service>
}
